import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAllFeedback } from "@/services/Feedback.ts";

import Spinner from "@/components/atoms/Spinner/Spinner.tsx";
import { Grid } from "@mantine/core";

import CTA from "@/components/atoms/CTA/index.tsx";
import AdminFeedbackTable from "@/components/organisms/StatusTable/AdminFeedbackTable.tsx";

import styles from "./styles.module.css";
import Heading from "@/components/atoms/Heading/index.tsx";
import dayjs from "dayjs";
import Drawer from "@/components/molecules/Drawer/index.tsx";

export default function AdminFeedback() {
  const { t } = useTranslation();

  const [allFeedbackData, setAllFeedbackData] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerLoading, setIsLoadingDrawer] = useState(false);
  const [feedbackInDrawer, setFeedbackInDrawer] = useState({});

  useEffect(() => {
    async function asyncgetAllFeedback() {
      setIsLoading(true);
      try {
        const response = await getAllFeedback();
        setAllFeedbackData(response.data);
        setIsLoading(false);
      } catch {
        // setErrorDialogOptions({
        //   message: t("commonAdmin:retrievingFailed"),
        //   error,
        // });
        // showErrorDialog(true);
      }
    }
    asyncgetAllFeedback().then();
  }, [t]);

  async function asyncApproveFeedback() {
    setIsLoading(true);
    try {
      // const response = await approveFeedback(feedbackId);
      await refreshFeedback();

      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  }

  async function asyncDeclineFeedback() {
    setIsLoading(true);
    try {
      // const response = await declineFeedback(feedbackId);
      await refreshFeedback();

      setIsLoading(false);
    } catch {
      // setErrorDialogOptions({
      //   message: t("commonAdmin:decliningFailed"),
      //   error,
      // });
      // showErrorDialog(true);
    }
  }

  async function refreshFeedback() {
    setIsLoading(true);
    try {
      const response = await getAllFeedback();
      setAllFeedbackData(response.data);
      setIsLoading(false);
    } catch {
      // setErrorDialogOptions({ message: t("commonAdmin:refreshFailed"), error });
      // showErrorDialog(true);
    }
  }

  async function openDrawerHandler(item) {
    setIsDrawerOpen(true);
    setIsLoadingDrawer(true);
    setFeedbackInDrawer(item);
    setIsLoadingDrawer(false);
  }

  async function declineFeedbackAndCloseDrawer() {
    await asyncDeclineFeedback(feedbackInDrawer.id);
    setIsDrawerOpen(false);
  }

  async function acceptFeedbackAndCloseDrawer() {
    await asyncApproveFeedback(feedbackInDrawer.id);
    setIsDrawerOpen(false);
  }
  return (
    <div className={styles.adminFeedbackRoot}>
      <title>Admin - Reviver - {t("commonAdmin:adminFeedback")}</title>
      <meta name="description" content="Admin - Reviver - {t('commonAdmin.adminFeedback')}" />
      <header className={styles.adminFeedbackHeader}>
        <Heading order={3} strong={true}>
          {t("commonAdmin:feedback")}
        </Heading>
      </header>
      <Spinner loading={loading} inline={true} align="center" />
      {!!allFeedbackData && <AdminFeedbackTable feedbackData={allFeedbackData} openDrawerHandler={openDrawerHandler} />}
      <Drawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
        <Spinner loading={isDrawerLoading} />
        {feedbackInDrawer && (
          <Grid>
            <Grid.Col span={4}>
              <h3>{t("commonAdmin:feedback")}</h3>
            </Grid.Col>

            <Grid.Col span={6}>
              <label>{t("commonAdmin:postedAt")}</label>
            </Grid.Col>
            <Grid.Col span={8}>
              <span>{dayjs(feedbackInDrawer.postedAt).format("MMMM Do YYYY, HH:mm")}</span>
            </Grid.Col>

            <Grid.Col span={6}>
              <label>{t("commonAdmin:comment")}</label>
            </Grid.Col>
            <Grid.Col span={8}>
              <span>{feedbackInDrawer.comment}</span>
            </Grid.Col>

            <Grid.Col span={6}>
              <label>{t("commonAdmin:rating")}</label>
            </Grid.Col>
            <Grid.Col span={8}>
              <span>{feedbackInDrawer.rating}</span>
            </Grid.Col>

            <Grid.Col span={6}>
              <label>{t("commonAdmin:receiverCompanyId")}</label>
            </Grid.Col>
            <Grid.Col span={8}>
              <span>{feedbackInDrawer.receiverCompanyId}</span>
            </Grid.Col>

            <Grid.Col span={6}>
              <label>{t("commonAdmin:senderCompanyId")}</label>
            </Grid.Col>
            <Grid.Col span={8}>
              <span>{feedbackInDrawer.senderCompanyId}</span>
            </Grid.Col>

            <Grid.Col>
              <label>
                <CTA intent="secondary" onClick={() => declineFeedbackAndCloseDrawer()} size="sm">
                  {t("commonAdmin:decline")}
                </CTA>
              </label>
            </Grid.Col>

            <Grid.Col>
              <label>
                <CTA onClick={() => acceptFeedbackAndCloseDrawer()} size="sm">
                  {t("commonAdmin:approve")}
                </CTA>
              </label>
            </Grid.Col>
          </Grid>
        )}
      </Drawer>
    </div>
  );
}
